export const NOTEBOOK_TITLE = "notebook-title";
export const NOTEBOOK_COMMENTS_TITLE = "notebook-comments-title";
export const NOTEBOOK_CONTENT_SECTION = "notebook-content-section";
